import { createActions, createState, createReducer } from 'reduxsauce-crud'

export const CheckinInventoryRedux = createActions(
  {
  },
  {
    prefix: 'CHECKIN_INVENTORY_',
    defaultActions: {
      get: true,
    },
  },
)

const { Types, Creators } = CheckinInventoryRedux
export const CheckinInventoryTypes = Types
export default Creators

export const INITIAL_STATE = createState({}, {
  get: true,
})

export const reducer = createReducer(
  INITIAL_STATE, {
  },
  {
    defaultActions: {
      get: true,
    },
    Types,
  },
)



// WEBPACK FOOTER //
// ./src/Data/Redux/CheckinInventoryRedux.js